// extracted by mini-css-extract-plugin
export default {"root":"_2rsaw5XA","rootInner":"_2Lng20kE"};